import Vue from "vue";
import Router from "vue-router";

// 引入公共路由
import baseRouter from "./baseRouter";

Vue.use(Router);

// 实例化vue-router
const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: baseRouter,
});
router.beforeEach((to, form, next) => {
  let token = localStorage.getItem("token");
  if (to.path != "/login") {
    // 判断用户是否登陆
    if (!token) {
      next({
        path: "/login",
      });
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;
